// src/modules/settings/customers/components/CustomerDialogs.tsx
import React from "react";
import CustomerForm from "./CustomerForm";
import DeleteCustomer from "../deletecustomer/DeleteCustomer";
import EditCustomer from "../edit-customer/components/EditCustomer";
import { CustomerData } from "src/shared/services/interfacev2";

interface CustomerDialogsProps {
  isEditOpen: boolean;
  isDeleteOpen: boolean;
  isAddOpen: boolean;
  selectedCustomer: CustomerData | null;
  onCloseEdit: () => void;
  onCloseDelete: () => void;
  onCloseAdd: () => void;
  onAddCustomer: (customerData: Partial<CustomerData>) => void;
  onRefetch: () => void;
  onResetSelection: () => void;
}

const CustomerDialogs: React.FC<CustomerDialogsProps> = ({
  isEditOpen,
  isDeleteOpen,
  isAddOpen,
  selectedCustomer,
  onCloseEdit,
  onCloseDelete,
  onCloseAdd,
  onAddCustomer,
  onRefetch,
  onResetSelection,
}) => {
  return (
    <>
      {isEditOpen && selectedCustomer && (
        <EditCustomer
          id={selectedCustomer._id.$oid}
          firstName={selectedCustomer.firstName?.split(" ")[0] ?? ""}
          middleName={selectedCustomer.middleName ?? ""}
          lastName={selectedCustomer.lastName?.split(" ").slice(-1).join(" ") ?? ""}
          phone={selectedCustomer.phones?.[0]?.phone ?? ""}
          alternativePhone={selectedCustomer.phones?.[1]?.phone ?? ""}
          email={selectedCustomer.emails?.[0]?.email ?? ""}
          address={selectedCustomer.addresses?.addressLine1 ?? ""}
          address2={selectedCustomer.addresses?.state ?? selectedCustomer.addresses?.addressLine2 ?? ""}
          address3={selectedCustomer.addresses?.city ?? ""}
          address4={selectedCustomer.addresses?.postalCode ?? ""}
          closeEditcustomer={() => {
            onCloseEdit();
            onResetSelection();
          }}
          refreshCustomerList={onRefetch}
        />
      )}

      {isDeleteOpen && selectedCustomer && (
        <DeleteCustomer
          id={selectedCustomer._id.$oid}
          name={selectedCustomer.firstName}
          refreshCustomerList={onRefetch}
          outStandingBalance={selectedCustomer.outstandingBalance}
          onClose={() => {
            onCloseDelete();
            onResetSelection();
          }}
        />
      )}

      <CustomerForm open={isAddOpen} onClose={onCloseAdd} onSubmit={onAddCustomer} />
    </>
  );
};

export default CustomerDialogs;
